import { render, staticRenderFns } from "./Teasers.vue?vue&type=template&id=154fb886&scoped=true"
import script from "./Teasers.vue?vue&type=script&lang=js"
export * from "./Teasers.vue?vue&type=script&lang=js"
import style0 from "./Teasers.vue?vue&type=style&index=0&id=154fb886&lang=less&scoped=true"
import style1 from "./Teasers.vue?vue&type=style&index=1&id=154fb886&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154fb886",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('154fb886')) {
      api.createRecord('154fb886', component.options)
    } else {
      api.reload('154fb886', component.options)
    }
    module.hot.accept("./Teasers.vue?vue&type=template&id=154fb886&scoped=true", function () {
      api.rerender('154fb886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/lib/components/Teasers.vue"
export default component.exports